module.exports = __webpack_public_path__ + "static/media/flecha-azul.ca4eb75e.png";